import { SearchComponent } from "@/App/Tenants/Search";
import { CreateLoaderTable } from "@/components/Loaders";
import { Main } from "@/components/Main";
import { useEffect, useState } from "react";
import { ApiDataProps } from "../Tenants";
import { TypePageActions } from "../Plans";
import { AddBtn } from "@/App/Estabilishments/Add";
import { TableData } from "@/App/Estabilishments/Table";
import {
  getEstablishmentsData,
  searchEstablishmentsData,
} from "@/Api/establishments";
import { usePermissions } from "@/hooks/usePermissions";
import { If } from "@/components/If";

export type TableDataProps = {
  id: number;
  uuid: string;
  name: string;
  image: string | null;
  address_id: number | null;
  is_active: boolean;
  tenant_id: number;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
  delivery_methods: any[];
  payment_forms: any[];
  unities: any[];
};

export const PageList = () => {
  const [listData, setListData] = useState({} as ApiDataProps<TableDataProps>);
  const [state, setState] = useState("loading");
  const { hasPermission } = usePermissions();

  useEffect(() => {
    (async () => {
      const { data } = await getEstablishmentsData();
      setListData(data?.response);
      setState("production");
    })();
  }, []);

  const pageActions: TypePageActions = {
    next: async () => {
      if (listData?.current_page < listData?.last_page) {
        setState("loading");

        const { data } = await getEstablishmentsData(
          listData?.current_page + 1
        );
        setListData(data.response);
        setState("production");
      }
      return;
    },
    previous: async () => {
      if (listData?.current_page > 1) {
        setState("loading");

        const { data } = await getEstablishmentsData(
          listData?.current_page - 1
        );
        setListData(data.response);
        setState("production");
      }
      return;
    },
    lastPage: async () => {
      if (listData?.current_page !== listData?.last_page) {
        setState("loading");

        const { data } = await getEstablishmentsData(listData?.last_page);
        setListData(data?.response);
        setState("production");
      }
      return;
    },
  };

  return (
    <Main>
      <If condition={hasPermission("view-establishments-list")}>
        <div className="flex justify-center md:justify-between items-center flex-wrap gap-2">
          <h2 className="text-2xl font-semibold flex gap-2 items-center">
            Estabelecimentos
          </h2>
          <If condition={hasPermission("create-establishment")}>
            <AddBtn updateFront={setListData} />
          </If>
        </div>
        <div className="flex flex-col gap-3">
          <SearchComponent
            updateFront={setListData}
            setState={setState}
            funcSearch={searchEstablishmentsData}
            placeholder="Pesquisar estabelecimentos"
          />
          {state === "loading" ? (
            <CreateLoaderTable cols={4} lines={6} />
          ) : (
            <TableData
              dataApi={listData}
              pageActions={pageActions}
              updateFront={setListData}
            />
          )}
        </div>
      </If>
    </Main>
  );
};
